import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TypographyVariant } from '../typography/typography.component';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html'
})

export class CardComponent {
  @Input() header: string = '';
  @Input() headerVariant: TypographyVariant = 'header';
  @Input() isClickable: boolean = false;
  @Input() roundedSmall: boolean = false;
  @Input() compactCard: boolean = false;
  @Input() smallPadding: boolean = false;
  @Input() bgTransparent: boolean = false;
  @Input() cardHeaderIcon: string = '';
  @Input() style: any;
  @Input() overviewHeight: boolean = false;
  @Input() padding: string = 'p-4';
  @Input() headerPaddingClass: string = 'mb-4 p-4';

  @Output() sendClickEvent = new EventEmitter;

  onClick(event: Event) {
    this.sendClickEvent.emit(event);
  }
}
